<template>
  <div class="animated fadeIn">
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <loading v-if="vLoading" />
    <v-dialog v-model="convertModal" width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>تبدیل پیش فاکتور {{ selected.invoiceCode }} به فروش</h4>
        </v-card-title>
        <v-card-text>
          <v-container class="mt-4">
            <p>نوع فروش را انتخاب کنید:</p>
            <v-select
              label="نوع فروش"
              :items="sellingTypes"
              v-model="convert.sellingType"
              outlined
              dense
            />
            <v-select
              v-if="convert.sellingType == 'definite'"
              label="نوع پرداخت"
              @change="check = {}"
              :items="paymentTypes"
              v-model="convert.paymentTypes"
              outlined
              dense
            />
            <div
              v-if="convert.paymentTypes == 'cheque'"
              class="pa-5 pt-10 mb-2"
              style="
                border: 1px solid #ccc;
                border-radius: 7px;
                position: relative;
              "
            >
              <p
                class="px-4"
                style="position: absolute; top: -9px; background-color: #fff"
              >
                اطلاعات چک را وارد کنید:
              </p>
              <v-row>
                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    label="* شماره چک"
                    v-model="check.number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    label="* نام بانک"
                    v-model="check.bankName"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0" sm="6" cols="12">
                  <label>* تاریخ چک</label>
                  <date-picker
                    v-model="check.date"
                    :editable="true"
                  ></date-picker>
                </v-col>
                <v-col class="py-0" sm="6" cols="12">
                  <v-text-field
                    class="mt-7"
                    label="شماره صیاد"
                    v-model="check.chequeSayyad"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
            <br />
            <v-textarea
              outlined
              dense
              label="توضیحات"
              rows="3"
              v-model="selected.description"
            ></v-textarea>
            <div class="text-left">
              <v-btn class="red white--text mx-1" @click="convertModal = false"
                >لغو</v-btn
              >
              <v-btn
                color="primary"
                class="mx-1"
                :loading="busy"
                @click="submit"
                :disabled="computedBtn"
                >ثبت</v-btn
              >
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-col lg="12" class="ml-auto"></v-col>
    <b-card
      v-if="$router.currentRoute.path == '/shop/preInvoices'"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <template v-slot:header>
        <v-row>
          <v-col>
            <h4 class="m-0 pt-1">مدیریت پیش فاکتورها</h4>
          </v-col>
          <v-col>
            <div
              @click="goToNewInvoice()"
              style="float: left"
              class="btn btn-dark"
            >
              + ثبت پیش فاکتور جدید +
            </div>
          </v-col>
        </v-row>
      </template>
      <br />
      <b-card class="shadow p-3 mb-5 bg-white rounded">
        <template v-slot:header>
          <v-row class="p-0">
            <v-col cols="4">
              <date-picker
                placeholder="تاریخ شروع"
                v-model="startDate"
                :editable="true"
              ></date-picker
            ></v-col>
            <v-col cols="4">
              <date-picker
                placeholder="تاریخ پایان"
                v-model="endDate"
                :editable="true"
              ></date-picker></v-col
            ><v-col cols="4">
              <b-btn class="btn btn-dark" @click="searchPreInvoices()"
                >جستجو</b-btn
              >
            </v-col>
          </v-row>
        </template>
        <v-row class="p-0">
          <v-col cols="12" class="pb-0 mt-3">
            <h6>
              <b-input-group size="md">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </h6>
          </v-col>
        </v-row>
        <br />
        <b-table
          responsive
          show-empty
          :items="preInvoices"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :current-page="currentPage"
          :per-page="perPage"
          :busy="isBusy"
          :filter="filter"
          id="preInvoices-table"
          @filtered="onFiltered"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(shopCustomerName)="data">
            <div style="text-align: center; vertical-align: middle">
              <router-link :to="'/shop/customer/' + data.item.shopCustomerId">{{
                data.value
              }}</router-link>
            </div>
          </template>
          <template v-slot:cell(invoiceCode)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }} ({{ data.item.type }})
            </div>
          </template>

          <template v-slot:cell(totalCost)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value.toLocaleString() }} ریال
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-btn
                :disabled="gettingReceipt"
                class="mr-1"
                variant="primary"
                @click="print(data.item, 'receipt')"
                >چاپ رسید</b-btn
              >
              <b-btn class="mr-1 red white--text" @click="openModal(data.item)"
                >تبدیل به فروش</b-btn
              >
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>

        <b-pagination
          v-model="currentPage"
          :total-rows="TotalRows"
          :per-page="perPage"
          aria-controls="preInvoices-table"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-card>
      <br />
    </b-card>
    <!-- receipt -->
    <v-card>
      <div id="Receipt" v-show="false">
        <table class="mainTable m-3 p-4 h-100 w-100">
          <thead>
            <tr>
              <td>
                <div style="text-align: center; width: 100%">
                  <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content" style="padding: 15px">
                  <div
                    style="
                      border: 1px solid black;
                      border-radius: 10px;
                      padding: 0 10px;
                      margin-bottom: 10px;
                    "
                  >
                    <div style="text-align: center">
                      <span style="font-size: 20px">پیش فاکتور</span>
                    </div>
                    <br />
                    <div>
                      <table style="border: 0px solid black !important">
                        <tr>
                          <td style="border: 0px solid black !important">
                            نام مشتری:
                            <span style="font-size = 16px">{{
                              printInvoice.shopCustomerName
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            شماره فاکتور:
                            <span style="font-size = 16px">{{
                              printInvoice.code
                            }}</span>
                            (چاپ مجدد)
                          </td>
                        </tr>
                        <tr>
                          <td style="border: 0px solid black !important">
                            کد مشتری:
                            <span style="font-size = 16px">{{
                              printInvoice.shopCustomerCode
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            تاریخ صدور:
                            <span style="font-size = 16px">{{
                              printInvoice.date
                            }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="border: 0px solid black !important">
                            نوع مشتری:
                            <span style="font-size = 16px">{{
                              printInvoice.shopCustomerType
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            ساعت صدور:
                            <span style="font-size = 16px">{{
                              printInvoice.time
                            }}</span>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <br />
                    <div>
                      <span style="float: right"> </span>
                      <span style="float: left"> </span>
                    </div>
                  </div>
                  <b-table
                    bordered
                    :fields="selectedFields"
                    :items="printInvoice.details"
                    small="small"
                    responsive
                  >
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell(name)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(amount)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(price)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value.toLocaleString() }} ریال
                      </div>
                    </template>
                    <template v-slot:cell(totalPrice)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          (
                            Number(data.item.amount) * data.item.price
                          ).toLocaleString()
                        }}
                        ریال
                      </div>
                    </template>
                  </b-table>
                  <br />
                  <div>
                    <span>
                      نوع فاکتور:
                      {{ printInvoice.type }}
                    </span>
                    <span style="float: left">
                      {{
                        "مبلغ کل: " +
                        Number(printInvoice.totalCost).toLocaleString()
                      }}
                      ریال
                    </span>
                  </div>
                  <br />
                  <div
                    style="
                      border: 1px solid black;
                      border-radius: 10px;
                      padding: 10px;
                      min-height: 75px;
                      break-inside: avoid;
                    "
                  >
                    <span> توضیحات: {{ printInvoice.description }}</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card>
    <v-card>
      <div id="convertReceipt" v-show="false">
        <table class="mainTable m-3 p-4 h-100 w-100">
          <thead>
            <tr>
              <td>
                <div style="text-align: center; width: 100%">
                  <span style="font-size: 22px">فروشگاه پولاد پیچکار</span>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content" style="padding: 15px">
                  <div
                    style="
                      border: 1px solid black;
                      border-radius: 10px;
                      padding: 0 10px;
                      margin-bottom: 10px;
                    "
                  >
                    <div style="text-align: center">
                      <span style="font-size: 20px">فاکتور فروش</span>
                    </div>
                    <div>
                      <br />
                      <table style="border: 0px solid black !important">
                        <tr>
                          <td style="border: 0px solid black !important">
                            نام مشتری:
                            <span style="font-size = 16px">{{
                              printInvoice.shopCustomerName
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            شماره فاکتور:
                            <span style="font-size = 16px">{{
                              printInvoice.code
                            }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="border: 0px solid black !important">
                            کد مشتری:
                            <span style="font-size = 16px">{{
                              printInvoice.shopCustomerCode
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            تاریخ صدور:
                            <span style="font-size = 16px">{{
                              selected.date
                            }}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="border: 0px solid black !important">
                            نوع مشتری:
                            <span style="font-size = 16px">{{
                              printInvoice.shopCustomerType
                            }}</span>
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            ساعت صدور:
                            <span style="font-size = 16px">{{
                              printInvoice.time
                            }}</span>
                          </td>
                        </tr>
                      </table>

                      <br />
                    </div>
                  </div>
                  <br />

                  <table
                    v-if="convert.paymentTypes == 'cheque'"
                    style="
                      border: 0px solid black !important;
                      break-inside: avoid;
                    "
                  >
                    <tr>
                      <td style="border: 0px solid black !important">
                        <span>
                          {{ "شیوه پرداخت: چک" }}
                        </span>
                      </td>
                      <td style="border: 0px solid black !important">
                        <span>
                          {{ "شماره چک: " + check.number }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="border: 0px solid black !important">
                        <span>
                          {{ "نام بانک: " + check.bankName }}
                        </span>
                      </td>
                      <td style="border: 0px solid black !important">
                        <span>
                          {{ "شماره صیاد: " + check.chequeSayyad }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style="border: 0px solid black !important">
                        <span>
                          {{ "تاریخ چک: " + check.date }}
                        </span>
                      </td>
                    </tr>
                    <tr></tr>
                  </table>

                  <div>
                    <span>
                      {{
                        "مبلغ کل: " +
                        Number(selected.totalCost).toLocaleString()
                      }}
                      ریال
                    </span>
                    <span
                      v-if="convert.paymentTypes != 'cheque'"
                      style="float: left"
                    >
                      نوع پرداخت:
                      {{
                        convert.sellingType == "definite"
                          ? "قطعی - پرداخت در لحظه"
                          : "امانی - پرداخت اعتباری"
                      }}
                      <span v-if="convert.sellingType == 'definite'">{{
                        " (" +
                        (convert.paymentTypes == "cash" ? "نقدی" : "کارتخوان") +
                        ")"
                      }}</span>
                    </span>
                  </div>
                  <br />
                  <div
                    style="
                      border: 1px solid grey;
                      border-radius: 10px;
                      min-height: 80px;
                      padding: 10px;
                      break-inside: avoid;
                    "
                  >
                    <span> توضیحات: {{ printInvoice.description }}</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card>
    <!-- receipt -->
    <br />
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import router from "../../router";
import moment from "moment-jalaali";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },

  data: function () {
    return {
      moment: moment,
      gettingReceipt: false,
      startDate: moment(new Date()).subtract(7, "days").format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      fields: [
        { key: "index", label: "ردیف" },
        { key: "shopCustomerName", label: "نام مشتری" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "expirationDate", label: "تاریخ اعتبار" },
        { key: "totalCost", label: "مبلغ" },
        { key: "operation", label: "عملیات" },
      ],
      invoiceTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
      ],
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
      ],
      selectedFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل" },
        // { key: "sum", label: "موجودی" },
        // { key: "operation", label: "عملیات" }
      ],
      customers: [],
      customerName: "",
      customerPriority: "",
      customerMobile: "",
      customerEmail: "",
      customerDialog: false,
      userInput: "",
      currentPage: 1,
      perPage: 10,
      TotalRows: 1,
      striped: true,
      selectedCustomer: {},
      isBusy: true,
      filter: "",
      preInvoices: [],
      selected: "",
      newInvoiceDialog: false,
      newInvoice: {
        customerBalance: "",
      },
      progress: false,
      customer: {},
      printInvoice: {},
      convertModal: false,
      sellingTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
      ],
      convert: {},
      busy: false,
      check: {},
      receiptType: "",
    };
  },

  methods: {
    openModal(item) {
      this.convert = {};
      this.check = {};
      this.convertModal = true;
      this.selected = item;
    },
    goToNewInvoice() {
      this.$router.push({
        path: "/shop/newSalesInvoice",
        query: { return: window.location.pathname },
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    submit() {
      let current = moment(new Date()).format("jYYYY/jMM/jDD");
      if (this.selected.expirationDate < current) {
        this.toast("پیش فاکتور معتبر نمی باشد", "error");
      } else {
        this.busy = true;
        Axios.post(
          this.baseUrl + "/ppkpms/shop/sales/convertProforma",
          {
            shopInvoiceId: this.selected.id,
            type: this.convert.sellingType,
            paymentType: this.convert.paymentTypes,
            chequeNo: this.check.number ? this.check.number : "",
            chequeDate: this.check.date ? this.check.date : "",
            chequeSayyad: this.check.chequeSayyad
              ? this.check.chequeSayyad
              : "",
            chequeBank: this.check.bankName ? this.check.bankName : "",
            description: this.selected.description
              ? this.selected.description
              : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            this.busy = false;
            if (res.status == 201) {
              this.toast(res.data, "success");
              this.convertModal = false;
              this.searchPreInvoices();
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
            }
          })
          .then(() => {
            this.print(this.selected, "convertReceipt");
          })
          .catch((err) => {
            this.busy = false;
            this.toast(err.response.data, "error");
          });
      }
    },
    print(item, type) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/getInfo",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          this.printReceipt(type);
        })
        .catch((err) => {
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt(type) {
      //printing receipt
      this.receiptType = type;
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      if (this.receiptType == "receipt") {
        myWindow.document.write(document.getElementById("Receipt").innerHTML);
      } else {
        myWindow.document.write(
          document.getElementById("convertReceipt").innerHTML
        );
      }

      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    searchPreInvoices() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/invoices",
        {
          type: "proforma",
          startDate: this.startDate + "00:00",
          endDate: this.endDate + "23:59",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.preInvoices = res.data;
            this.TotalRows = this.preInvoices.length;
            this.vLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.vLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
          this.vLoading = false;
        });
    },
  },
  computed: {
    totalCost() {
      return 1000;
    },
    computedBtn() {
      if (this.convert.paymentTypes == "cheque") {
        if (!this.check.number || !this.check.bankName || !this.check.date) {
          return true;
        } else return false;
      }
    },
  },

  mounted() {
    this.searchPreInvoices();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
